import { render, staticRenderFns } from "./PhoneInputV1Properties.vue?vue&type=template&id=5997c820&"
import script from "./PhoneInputV1Properties.vue?vue&type=script&lang=js&"
export * from "./PhoneInputV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports